import React from "react";
import { canThisBeNumber } from "resbutler-utils/utils";
import { MoneyUtils } from "resbutler-utils/utils/MoneyUtils";

interface DollarPriceInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> {
  value: number | null;
  onChange: (value: number | null) => void;
}
export const DollarPriceInput: React.FC<DollarPriceInputProps> = ({ value, onChange, ...props }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    e.preventDefault();

    const rawValue = canThisBeNumber(e.target.value) ? Number(e.target.value) : null;
    const cents = MoneyUtils.dollarsToCents(rawValue);
    onChange(cents);
  };

  // React skips writing to the DOM when the `value` prop is null/undefined
  // (`if (props.value != null)` in ReactDOM's input update), which leaves the
  // last typed digit visible after the field is cleared programmatically —
  // e.g. the on-screen keyboard's backspace, which never touches the real input.
  // Render "" for the empty state so React always controls the node.
  const displayValue = value === null || value === undefined ? "" : MoneyUtils.centsToDollars(value);
  return <input type="number" step={0.01} {...props} value={displayValue} onChange={handleChange} />;
};
